module.exports = __webpack_public_path__ + "static/media/image-add-line.cea829f2.svg";